/**
 * Expired Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const EXPIRED = 'expired';
//# sourceMappingURL=EXPIRED.js.map